module.exports = __webpack_public_path__ + "img/imparfaite-logo.ebe9c97d.svg";